import { useState } from 'react';
import { ReportChannelsModal } from './ReportChannelsModal';
import { ReportChannelsInteractorProps, useReportChannelsInteractor } from './interactor';
import { CycleController } from '../../../../../../../store/models/controllers';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../../../../Tooltip';
import InteractiveButton from '../../../../../../InteractiveButton/InteractiveButton';
import IconMultipleLines from '../../../../../../Icons/MultipleLines/MultipleLines';
import { ElementSize } from '../../../../../../../types/element-size';

export interface IReportChannelsWrapperProps extends ReportChannelsInteractorProps {
  cycleControllers: CycleController[];
}

export const ReportChannelsWrapper = (props: IReportChannelsWrapperProps) => {
  const { cycleControllers, ...interactorProps } = props;
  const { channelNames, excludedChannelNames, onSubmitFormHandler, colorsDevices, canEdit } =
    useReportChannelsInteractor({
      ...interactorProps,
    });

  const { t } = useTranslation();

  const [isEditReportChannels, setIsEditReportChannels] = useState<boolean>(false);

  const openModalReportChannels = () => {
    setIsEditReportChannels(true);
  };

  const closeModalReportChannels = () => {
    setIsEditReportChannels(false);
  };

  if (!canEdit || !cycleControllers) {
    return null;
  }

  return (
    <>
      <Tooltip hint={t('labels.editLineColors')} hintClassName="left-[50%] bottom-9">
        <InteractiveButton
          onClick={openModalReportChannels}
          customType="max-h-fit max-w-fit border border-foggy-mist rounded active:border-primary cursor-pointer min-w-fit"
          style={{ padding: ' 0px 12px' }}
        >
          <IconMultipleLines stroke="inherit" iconClassName="text-inherit" size={ElementSize.MD} />
        </InteractiveButton>
      </Tooltip>

      {isEditReportChannels && (
        <ReportChannelsModal
          onClose={closeModalReportChannels}
          cycleControllers={cycleControllers}
          excludedDevices={excludedChannelNames}
          channelNames={channelNames}
          colorsDevices={colorsDevices}
          onSubmit={onSubmitFormHandler}
        />
      )}
    </>
  );
};
